// /types/languageTypes.ts
import { ReactNode, useState } from "react";
import LanguageContext from "../contexts/languageContext";
import { LanguageType } from "../types/languageTypes";

interface LanguageProviderProps {
  children: ReactNode;
}

// Provider 컴포넌트는 언어 상태를 관리하고 자식 컴포넌트들에게 제공합니다
export default function LanguageProvider({ children }: LanguageProviderProps) {
  const [language, setLanguage] = useState<LanguageType>("en");

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "ko" : "en"));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
